
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ItemDisplay } from '@/models';

export default class Item extends Vue {
  @Prop({ required: true }) item!: ItemDisplay;
}
